import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRolePermissionResponse } from '../models/user-roles-permissions';
import { ApiResponse } from '../models/api-response';
import { HttpClient } from '@angular/common/http';
import { API_ENDPOINTS, buildEndpoint } from '../api-endpoint';
import { RuntimeConfigService } from '../config/runtime-config.service';

export interface User {
  name: string;
  initials: string;
  icon: string;
  disabled: boolean;
  role: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private baseApiUrl: string;
  private apiVersion: string;
  constructor(private runtimeConfigService: RuntimeConfigService, private http: HttpClient) {
    this.baseApiUrl = this.runtimeConfigService.apiUrl;
    this.apiVersion = this.runtimeConfigService.apiVersion;
  }

  getApiUrl(apiEndpoint: string): string {
    return buildEndpoint(this.baseApiUrl, this.apiVersion, 'reportservice', apiEndpoint);
  }

  getUserPermissions(id: string): Observable<ApiResponse<UserRolePermissionResponse>> {
    const url = this.getApiUrl(API_ENDPOINTS.REPORT_SERVICE.PERMISSIONS.UserPermissions).replace(
      '{id}',
      id
    );
    return this.http.get<ApiResponse<UserRolePermissionResponse>>(url);
  }
}
